import './assets/main.css'
import { createApp } from 'vue'
import { createPinia } from 'pinia'
import App from './App.vue'
import router from './router'
import request from '@/utils/request'
import { decrypt } from './utils/loginUtil'
import { notify } from './utils/notify'

const app = createApp(App)
app.config.globalProperties.$axios = request
// @ts-ignore
const url = import.meta.env.VITE_WEB_BASE_URL;
// @ts-ignore
const apiurl = import.meta.env.VITE_API_BASE_URL;
console.log("webUrl:" + `${url}`)
console.log("apiUrl:" + `${apiurl}`)
async function startVue() {
  // 1. 等待 Office 准备好（如果存在）
  if (window.Office?.onReady) {
    await Office.onReady()
  }
  // 2. Office 初始化完 **之后**，再 use 路由
  app.use(createPinia())
  app.use(router)
  app.mount('#app')
}
startVue();